import PromotionsPage from "features/Dashboard/pages/PromotionsPage.tsx";
import { ProtectedRoute } from "./ProtectedRoute";

export const PromotionsRoutes = ProtectedRoute({
	path: "promotions",
	element: <PromotionsPage />
});
